import app from 'flarum/forum/app';
import Extend from 'flarum/common/extenders';
import IndexPage from 'flarum/forum/components/IndexPage';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionTaggedPost from './components/DiscussionTaggedPost';
import commonExtend from '../common/extend';
export default [...commonExtend, new Extend.Routes() //
.add('tag', '/t/:tags', IndexPage) //
.helper('tag', tag => app.route('tag', {
  tags: tag.slug()
})), new Extend.PostTypes() //
.add('discussionTagged', DiscussionTaggedPost), new Extend.Model(Discussion) //
.hasMany('tags') //
.attribute('canTag')];